import { Controller } from '@hotwired/stimulus'

export default class extends Controller {
  static targets = ['checkbox', 'authorizations']

  connect() {
    // Since reader is role selected by default
    this.checkAll()
  }

  updateAuthorizations = event => {
    if (!this.hasAuthorizationsTarget) return

    const role = event.target.value
    this.checkRoles(role)
    role === 'admin' ? this.hideAuthorizations() : this.showAuthorizations()
  }

  checkRoles = role => {
    switch (role) {
      case 'reader':
        this.checkAll()
        break
      case 'admin':
        this.disableAll()
        break
      default:
        this.enableAll()
        break
    }
  }

  hideAuthorizations() {
    this.authorizationsTarget.classList.add('d-none')
  }

  showAuthorizations() {
    this.authorizationsTarget.classList.remove('d-none')
  }

  checkAll() {
    if (!this.someChecked()) {
      this.checkboxTargets.forEach(checkbox => (checkbox.checked = true))
    }
  }

  disableAll() {
    this.checkboxTargets.forEach(checkbox => (checkbox.disabled = true))
  }

  enableAll() {
    this.checkboxTargets.forEach(checkbox => (checkbox.disabled = false))
  }

  someChecked() {
    return this.checkboxTargets.some(checkbox => checkbox.checked)
  }
}
